<template>
  <section class="catalog-products" style="width: 100%; height: 100%">
    <div
      class="modal-card"
      style="width: 100%; height: 100%; max-height: none; padding: 0"
    >
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ catalogName }} -
          {{ $t('attributes.catalog') + $t('attributes.banner') }}
          ({{ count }} / {{ total }})
        </p>
      </header>
      <section class="modal-card-body">
        <b-table
          :data="items"
          :loading="loading"
          :mobile-cards="false"
          bordered
          draggable
          @dragstart="dragstart"
          @drop="drop"
          @dragover="dragover"
          @dragleave="dragleave"
        >
          <b-table-column
            :width="80"
            :label="$t('attributes.function')"
            centered
            v-slot="props"
          >
            <b-button
              type="is-danger"
              size="is-small"
              outlined
              @click.prevent.stop="onRemove(props.row)"
            >
              {{ $t('attributes.remove') }}
            </b-button>
          </b-table-column>
          <b-table-column
            field="sort"
            :label="$t('attributes.sort_drag')"
            numeric
            centered
            width="100"
            v-slot="props"
          >
            {{ props.row.sort }}
          </b-table-column>
          <b-table-column
            field="status"
            :label="
              $t('attributes.tourist_info') + $t('attributes.activation_status')
            "
            width="150"
            sortable
            centered
            v-slot="props"
          >
            <b-tag
              :type="props.row.status ? 'is-info' : 'is-danger'"
              size="is-medium"
            >
              {{ activeStatus(props.row.status) }}
            </b-tag>
          </b-table-column>
          <b-table-column
            field="title"
            :label="$t('attributes.name')"
            v-slot="props"
          >
            <p v-html="props.row.name"></p>
          </b-table-column>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons is-right" style="width: 100%;">
          <button class="button" type="button" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </button>
          <b-button
            :loading="sending || loading"
            type="is-primary"
            @click="updateSort"
          >
            {{ $t('attributes.update') + $t('attributes.sort') }}
          </b-button>
        </div>
      </footer>
    </div>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'CatalogBannersFrom',
  props: {
    catalogNo: {
      required: true,
      type: String
    },
    catalogName: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      items: [],
      off_items: [],
      count: 0,
      total: 0,

      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  watch: {
    catalogNo(newCatalogNo) {
      this.loadItems(newCatalogNo)
    }
  },
  mounted() {
    this.loadItems(this.catalogNo)
  },
  methods: {
    async loadItems(catalogNo) {
      try {
        const api = `${CATALOG_API}/${catalogNo}/banners`

        this.loading = true
        const res = await this.axios.get(api)
        this.total = res.data.data.length
        this.items = res.data.data.filter(p => p.status)
        this.off_items = res.data.data.filter(p => !p.status)
        this.count = this.items.length
      } catch (e) {
        this.items = []
        this.total = 0
        this.off_items = []
        this.count = 0

        notifyService.fetch_error('tourist-info', e)
      } finally {
        this.loading = false
      }
    },
    async updateSort() {
      try {
        const items = this.items.map(item => ({
          id: item.id,
          sort: item.sort
        }))
        const off_items = this.off_items.map(item => ({
          id: item.id,
          sort: item.sort
        }))

        items.push(...off_items)

        this.sending = true
        const api = `${CATALOG_API}/banners/sort`
        await this.axios.put(api, {
          items: items
        })

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async onRemove(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    async deleteItem(item) {
      try {
        this.sending = true
        const api = `${CATALOG_API}/banners/catalog/${item.id}`
        await this.axios.delete(api)

        this.items = this.items.filter(t => t.id !== item.id)
        this.count = this.items.length

        notifyService.success(this.$t('attributes.remove_succeed'))
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      let items = [...this.items]
      items.splice(this.draggingRowIndex, 1)
      items.splice(droppedOnRowIndex, 0, this.draggingRow)
      this.items = items.map((item, idx) => {
        return { ...item, sort: idx + 1 }
      })
    }
  }
}
</script>
